/**
 * HLF Our Promise / Reports Modal Controller
 * Uses event delegation on document for dynamic compatibility
 */

(function() {
  // Move modals to body on init to prevent z-index / clipping issues inside nested flex containers
  const moveModalsToBody = () => {
    document.querySelectorAll('.hlf-promise-modal').forEach(modal => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  };

  // Run immediately and on DOM content load
  moveModalsToBody();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveModalsToBody);
  }

  // Reset slider to page 0
  const openModal = (modal) => {
    // Close other open modals
    document.querySelectorAll('.hlf-promise-modal.is-open').forEach(m => {
      m.classList.remove('is-open');
    });
    
    // Double-ensure it is in body to avoid layout clipping
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    
    document.body.classList.add('hlf-modal-active');
    modal.classList.add('is-open');
    initSlider(modal);
  };

  const closeModal = (modal) => {
    modal.classList.remove('is-open');
    document.body.classList.remove('hlf-modal-active');
  };

  // Click handler delegation
  document.addEventListener('click', (e) => {
    // 1. Open modal trigger
    const trigger = e.target.closest('[data-modal-trigger]');
    if (trigger) {
      const modalId = trigger.dataset.modalTrigger;
      const modal = document.getElementById(modalId);
      if (modal) {
        openModal(modal);
      }
      return;
    }

    // 2. Close modal triggers
    if (e.target.closest('.hlf-promise-modal__close') || 
        e.target.closest('.hlf-promise-modal__backdrop') || 
        e.target.closest('.hlf-promise-modal__cta')) {
      const activeModal = e.target.closest('.hlf-promise-modal');
      if (activeModal) {
        closeModal(activeModal);
      }
    }
  });

  // Keyboard Escape close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.hlf-promise-modal.is-open');
      if (activeModal) {
        closeModal(activeModal);
      }
    }
  });

  // Slider Logic for each Modal
  function initSlider(modal) {
    const track = modal.querySelector('.hlf-promise-slider__track');
    const slides = modal.querySelectorAll('.hlf-promise-slider__slide');
    const prevBtn = modal.querySelector('.hlf-promise-slider__arrow--prev');
    const nextBtn = modal.querySelector('.hlf-promise-slider__arrow--next');
    const dots = modal.querySelectorAll('.hlf-promise-slider__dot');
    
    if (!track || slides.length === 0) return;
    
    let currentIndex = 0;
    const maxIndex = slides.length - 1;
    
    const updateSlider = (index) => {
      currentIndex = index;
      if (currentIndex < 0) currentIndex = 0;
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      
      // Slide track transition
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // Update active classes for slides
      slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === currentIndex);
      });
      
      // Update active classes for dots
      dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === currentIndex);
      });
    };

    // Reset slider position on load/open
    updateSlider(0);

    // Chevron handlers
    if (prevBtn) {
      prevBtn.onclick = (e) => {
        e.stopPropagation();
        if (currentIndex > 0) {
          updateSlider(currentIndex - 1);
        }
      };
    }
    
    if (nextBtn) {
      nextBtn.onclick = (e) => {
        e.stopPropagation();
        if (currentIndex < maxIndex) {
          updateSlider(currentIndex + 1);
        }
      };
    }

    // Dot handlers
    dots.forEach((dot, idx) => {
      dot.onclick = (e) => {
        e.stopPropagation();
        updateSlider(idx);
      };
    });

    // Touch support (swipe gestures)
    let startX = 0;
    let endX = 0;
    
    const sliderContainer = modal.querySelector('.hlf-promise-slider');
    if (sliderContainer) {
      sliderContainer.ontouchstart = (e) => {
        startX = e.touches[0].clientX;
      };
      
      sliderContainer.ontouchend = (e) => {
        endX = e.changedTouches[0].clientX;
        handleSwipe();
      };
    }
    
    function handleSwipe() {
      const diffX = startX - endX;
      const minSwipeDistance = 50; // pixels
      
      if (Math.abs(diffX) > minSwipeDistance) {
        if (diffX > 0 && currentIndex < maxIndex) {
          // swiped left -> next
          updateSlider(currentIndex + 1);
        } else if (diffX < 0 && currentIndex > 0) {
          // swiped right -> prev
          updateSlider(currentIndex - 1);
        }
      }
    }
  }
})();
